<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>